import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-founded",
  "use": "icon-founded-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-founded\"><path d=\"M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m316.78 828.78a446.4 446.4 0 1 1 96-142.42 446.59 446.59 0 0 1-96 142.42z\" fill=\"#1F1F21\" p-id=\"13193\" /><path d=\"M672 512H512V224a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32h192a32 32 0 0 0 0-64z\" fill=\"#1F1F21\" p-id=\"13194\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol